var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7443",
    "data-name": "Group 7443",
    transform: "translate(14591 9628)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21950",
    "data-name": "Ellipse 21950",
    cx: 2.097,
    cy: 2.097,
    r: 2.097,
    transform: "translate(-14569.477 -9618) rotate(90)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21951",
    "data-name": "Ellipse 21951",
    cx: 2.097,
    cy: 2.097,
    r: 2.097,
    transform: "translate(-14576.477 -9618) rotate(90)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21952",
    "data-name": "Ellipse 21952",
    cx: 2.097,
    cy: 2.097,
    r: 2.097,
    transform: "translate(-14583.477 -9618) rotate(90)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25272",
    "data-name": "Rectangle 25272",
    width: 24,
    height: 24,
    transform: "translate(-14591 -9628)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIcon);
export default __webpack_public_path__ + "static/media/options-icon.6b84914f41f377b327ae9ddcd8644b6d.svg";
export { ForwardRef as ReactComponent };